import { ref } from 'vue';

export function usePromise<T, TArgs extends readonly unknown[] = []>(
  promise: (...args: TArgs) => Promise<T>,
) {
  const data = ref<T>();
  const pending = ref(false);
  const error = ref<Error | false>(false);
  const resolved = ref(false);

  async function run(...args: TArgs) {
    try {
      pending.value = true;
      error.value = false;
      resolved.value = false;
      data.value = await promise(...args);
      resolved.value = true;
    } catch (e) {
      error.value = e instanceof Error ? e : new Error(String(e));
    } finally {
      pending.value = false;
    }
  }

  return {
    data,
    pending,
    error,
    resolved,
    run,
  };
}
